import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createArticle,
  getOneArticle,
  getAllArticles,
} from "redux/actions/article.action";
import Loader from "components/Loader/Loader";
import "./Blogs.css";
import PageNotFound from "components/PageNotFound/PageNotFound";
import { convertTime } from "utils/ConvertTime";
import Footer from "components/Footer/Footer";

const SingleBlog = () => {
  const dispatch: any = useDispatch();
  const articleState = useSelector(
    (state: any) => state.fetchOneArticleReducer
  );

  const articleId = window.location.href.substring(
    window.location.href.lastIndexOf("/") + 1
  );

  React.useEffect(() => {
    dispatch(getOneArticle(articleId));
  }, []);

  const newText = articleState?.article?.data?.description.split("\n");

  return (
    <div className="relative dark:text-white w-[100vw] max-w-[1400px] mx-auto min-h-[100vh] bg-[#fff] dark:bg-[#002137]">
      {articleState.pending ? (
        <div className="vertical-center">
          <Loader />
        </div>
      ) : (
        <>
          <div className="pt-10">
            <h1 className="text-[2em] text-center underline uppercase mb-10">
              {articleState?.article?.data?.title}
            </h1>
            <img
              src={articleState?.article?.data?.image}
              alt=""
              className="semi-md:w-[70%] max-h-[70vh] w-[90%] aspect-[5/3] mx-auto object-cover"
            />
            <p className="text-[14px] my-3 ml-[5%] semi-md:ml-[15%] text-[#0093df] font-medium">
              {convertTime(`${articleState?.article?.data?.createdAt}`)}
            </p>
            <p className="semi-md:w-[60%] w-[90%] mx-auto">
              {newText?.map((values: any, idx: any) => {
                return (
                  <p key={idx} className="mb-2">
                    {values}
                  </p>
                );
              })}
            </p>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
};

export default SingleBlog;
